module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.activitiesList), function(act) {
    return _c('div', {
      staticClass: "item activities"
    }, [(act.match && act.match.level === 0) ? [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('p', [_c('user-link', {
      attrs: {
        "who": act.user
      }
    }), _vm._v(" hat das Finale des Turniers \"" + _vm._s(act.tournament.name) + "\"\n                gegen "), _c('user-link', {
      attrs: {
        "who": act.user2
      }
    }), _vm._v(" gewonnen!\n            ")], 1)] : (act.type == 'match-played') ? [_c('div', {
      staticClass: "double-dp"
    }, [_c('dp', {
      attrs: {
        "who": act.user
      }
    }), _vm._v(" "), _c('dp', {
      attrs: {
        "who": act.user2
      }
    })], 1), _vm._v(" "), (act.match.won === undefined) ? _c('p', [_c('user-link', {
      attrs: {
        "who": act.user
      }
    }), _vm._v(" \n                hat gegen \n                "), _c('user-link', {
      attrs: {
        "who": act.user2
      }
    }), _vm._v(" "), (act.match.level !== null) ? [_vm._v("\n                    im " + _vm._s(_vm._f("round_name")(act.match.level)) + " des Turniers " + _vm._s(act.tournament.name) + "\n                ")] : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("score")(act.match)) + " \n                gespielt.\n            ")], 2) : _vm._e(), _vm._v(" "), (act.match.won === true) ? _c('p', [_vm._v("\n                Du hast gegen \n                "), _c('user-link', {
      attrs: {
        "who": act.match.player_other
      }
    }), _vm._v(" "), (act.match.level !== null) ? [_vm._v("\n                    im " + _vm._s(_vm._f("round_name")(act.match.level)) + " des Turniers " + _vm._s(act.tournament.name) + "\n                ")] : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("score")(act.match)) + " \n                gewonnen!\n                "), _c('strong', [_vm._v("ELO " + _vm._s(_vm._f("plusminus")(act.match.elo_me_delta)))]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-secondary",
      attrs: {
        "to": "/profile/me/stats"
      }
    }, [_vm._v("Statistik")])], 2) : _vm._e(), _vm._v(" "), (act.match.won === false) ? _c('p', [_vm._v("\n                Schade! Du hast gegen \n                "), _c('user-link', {
      attrs: {
        "who": act.match.player_other
      }
    }), _vm._v(" "), (act.match.level !== null) ? [_vm._v("\n                    im " + _vm._s(_vm._f("round_name")(act.match.level)) + " des Turniers " + _vm._s(act.tournament.name) + "\n                ")] : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("score")(act.match)) + "\n                verloren.\n                "), _c('strong', [_vm._v("ELO " + _vm._s(_vm._f("plusminus")(act.match.elo_me_delta)))]), _vm._v(" "), _c('router-link', {
      staticClass: "btn-secondary",
      attrs: {
        "to": "/profile/me/stats"
      }
    }, [_vm._v("Statistik")])], 2) : _vm._e()] : (act.type == 'post-text') ? [_c('dp', {
      attrs: {
        "who": act.user
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("name")(act.user)) + ":")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "linkified",
        rawName: "v-linkified"
      }],
      domProps: {
        "innerHTML": _vm._s(act.message)
      }
    })]), _vm._v(" "), (act.photo && !_vm.big) ? _c('router-link', {
      staticClass: "photos",
      attrs: {
        "to": ("/timeline/" + (act.id))
      }
    }, _vm._l((act.num_photos), function(index) {
      return _c('img', {
        attrs: {
          "src": ("/storage/photos/" + (act.photo) + "_" + (index-1) + "_small.jpg")
        }
      })
    })) : _vm._e(), _vm._v(" "), (_vm.big) ? _c('div', {
      staticClass: "photos big"
    }, _vm._l((act.num_photos), function(index) {
      return _c('img', {
        attrs: {
          "src": ("/storage/photos/" + (act.photo) + "_" + (index-1) + "_big.jpg")
        }
      })
    })) : _vm._e()] : (act.type == 'tournament-started') ? [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('p', [_vm._v("\n                Das Turnier \"" + _vm._s(act.tournament.name) + "\" hat begonnen.\n            ")])] : _vm._e(), _vm._v(" "), _c('small', {
      staticClass: "pale"
    }, [_c('router-link', {
      attrs: {
        "to": ("/timeline/" + (act.id))
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("time")(act.updated_at)) + "\n            ")])], 1), _vm._v(" "), (!_vm.admin) ? _c('div', {
      staticClass: "actions"
    }, [_c('a', {
      staticClass: "comment",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.commentingOn = act.id
        }
      }
    }), _vm._v(" "), _c('a', {
      class: [act.liked ? 'red' : '', 'like'],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.like(act)
        }
      }
    }), _vm._v(" "), (act.num_likes > 0) ? _c('span', {
      staticClass: "num-likes"
    }, [_vm._v("\n                " + _vm._s(_vm.listLikes(act)) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.admin && act.type == 'post-text') ? _c('div', {
      staticClass: "actions"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deletePost(act)
        }
      }
    }, [_vm._v("Löschen")])]) : _vm._e(), _vm._v(" "), (act.comments.length > 0 || _vm.commentingOn == act.id) ? _c('div', {
      staticClass: "comments"
    }, [_vm._l((act.comments), function(comment) {
      return _c('div', {
        staticClass: "item"
      }, [_c('dp', {
        attrs: {
          "who": comment.author
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "message"
      }, [_c('strong', [_vm._v(_vm._s(_vm._f("name")(comment.author)) + ":")]), _vm._v(" "), _c('span', {
        directives: [{
          name: "linkified",
          rawName: "v-linkified"
        }],
        domProps: {
          "innerHTML": _vm._s(comment.message)
        }
      })]), _vm._v(" "), (_vm.admin) ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.deleteComment(act, comment)
          }
        }
      }, [_vm._v("Löschen")]) : _vm._e()], 1)
    }), _vm._v(" "), (_vm.commentingOn == act.id) ? _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.comment(act)
        }
      }
    }, [_c('dp', {
      attrs: {
        "who": _vm.user
      }
    }), _vm._v(" "), _c('div', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commentMessage),
        expression: "commentMessage"
      }],
      domProps: {
        "value": (_vm.commentMessage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.commentMessage = $event.target.value
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "btn-primary",
      attrs: {
        "type": "submit",
        "value": "Kommentieren"
      }
    })])], 1) : _vm._e()], 2) : _vm._e()], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36707d52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline.vue
// module id = 99
// module chunks = 0 1